export function formatSecondsIntoTimer(seconds: number): string {
  const s = seconds % 60;
  const m = Math.floor(seconds / 60) % 60;
  const h = Math.floor(seconds / 3600);

  const ret = [];
  ret.push(`${h}`);

  ret.push(`${m < 10 ? `0${m}` : `${m}`}`);

  ret.push(`${s < 10 ? `0${s}` : `${s}`}`);

  return ret.join(":");
}

export const kronosSecondsSplice = (seconds?: number) => {
  if (!seconds) return undefined;
  const s = Math.floor(seconds % 60);
  const m = Math.floor(seconds / 60) % 60;
  const h = Math.floor(seconds / 3600);

  const ret = [];
  ret.push(`${h}`);

  ret.push(`${m}`);

  ret.push(`${s}`);

  return ret;
};

/**
 * @param  {Array<T>} elements
 * @returns Map
 */
export function arrayToMap<T extends { id: number }>(
  elements: Array<T>
): { [key: number]: T } {
  const ret: { [t: number]: T } = {};
  for (const key in elements) {
    if (Object.prototype.hasOwnProperty.call(elements, key)) {
      const element = elements[key];
      ret[element.id] = element;
    }
  }
  return ret;
}

/**
 * @param  {Map<number} elements
 * @returns Map
 */
export function mapToArray<T extends { id: number }>(elements: {
  [key: number]: T;
}): Array<T> {
  const ret = new Array<T>();
  for (const key in elements) {
    if (Object.prototype.hasOwnProperty.call(elements, key)) {
      const element = elements[key];
      ret.push(element);
    }
  }

  return ret;
}
